<!-- Register Clinic Dialog Container -->
<div class="register-clinic-container">
  <!-- Header Section -->
  <div class="clinic-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="clinic-title">
          <i class="pi pi-building mr-3"></i>
          {{ data ? "Update Clinic" : "Register New Clinic" }}
        </h1>
        <p class="clinic-subtitle">
          {{
            data
              ? "Update clinic information and details"
              : "Create a new clinic with complete information"
          }}
        </p>
      </div>
      <div class="header-right">
        <div class="clinic-status">
          <i class="pi pi-file-edit status-icon"></i>
          {{ data ? "Edit Mode" : "New Registration" }}
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="clinic-content">
    <form [formGroup]="clinicForm" (ngSubmit)="onSubmit()" class="clinic-form">
      <!-- Basic Information Section -->
      <div class="content-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-info-circle mr-2"></i>
            Basic Information
          </h2>
        </div>

        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-building mr-2"></i>
              Clinic Name *
            </label>
            <input
              type="text"
              formControlName="name"
              class="modern-input"
              placeholder="Enter clinic name"
            />
            <div
              *ngIf="submitted && clinicForm.get('name')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['name'] &&
                  f['name'].errors &&
                  f['name'].errors['required']
                "
                severity="error"
                text="Please enter a clinic name"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-user mr-2"></i>
              Head Nurse *
            </label>
            <p-dropdown
              [options]="nurses"
              optionLabel="first_name"
              optionValue="id"
              placeholder="Select a nurse"
              [virtualScroll]="true"
              [itemSize]="40"
              [lazy]="true"
              [filter]="true"
              [showClear]="true"
              (onFilter)="loadNurses($event)"
              formControlName="professional_nurse"
              [showClear]="true"
              appendTo="body"
              class="modern-dropdown w-full"
              (onChange)="onNurseDropdownChange($event)"
            >
            </p-dropdown>
            <div
              *ngIf="submitted && clinicForm.get('professional_nurse')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['professional_nurse'] &&
                  f['professional_nurse'].errors &&
                  f['professional_nurse'].errors['required']
                "
                severity="error"
                text="Please select a nurse"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>
        </div>
      </div>

      <!-- Address Information Section -->
      <div class="content-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-map-marker mr-2"></i>
            Address Information
          </h2>
        </div>

        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-home mr-2"></i>
              Street Address
            </label>
            <input
              type="text"
              formControlName="street_address"
              class="modern-input"
              placeholder="Enter street address"
            />
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-map mr-2"></i>
              Suburb
            </label>
            <input
              type="text"
              formControlName="suburb"
              class="modern-input"
              placeholder="Enter suburb"
            />
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-building mr-2"></i>
              City/Town
            </label>
            <input
              type="text"
              formControlName="city"
              class="modern-input"
              placeholder="Enter city or town"
            />
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-globe mr-2"></i>
              District
            </label>
            <input
              type="text"
              formControlName="district"
              class="modern-input"
              placeholder="Enter district"
            />
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-flag mr-2"></i>
              Province *
            </label>
            <p-dropdown
              [options]="provinces"
              optionLabel="name"
              optionValue="name"
              placeholder="Select a province"
              class="modern-dropdown"
              appendTo="body"
              formControlName="province"
              (onChange)="onProvinceChange($event)"
            ></p-dropdown>
            <div
              *ngIf="submitted && clinicForm.get('province')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['province'] &&
                  f['province'].errors &&
                  f['province'].errors['required']
                "
                severity="error"
                text="Please select a province"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-dollar"></i>
              Credit Limit *
            </label>
            <input
              type="number"
              formControlName="credit_limit"
              class="modern-input"
              placeholder="Enter credit limit"
              min="0"
            />
            <div
              *ngIf="submitted && clinicForm.get('credit_limit')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['credit_limit'] &&
                  f['credit_limit'].errors &&
                  f['credit_limit'].errors['required']
                "
                severity="error"
                text="Please enter a credit limit"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-envelope mr-2"></i>
              Postal Code
            </label>
            <input
              type="text"
              formControlName="postal_code"
              class="modern-input"
              placeholder="Enter postal code"
            />
          </div>
        </div>
      </div>

      <!-- Action Buttons Section -->
      <div class="content-section action-section">
        <div class="action-buttons">
          <button
            type="button"
            class="action-btn secondary"
            (click)="closeDialog()"
          >
            <i class="pi pi-times mr-2"></i>
            Cancel
          </button>
          <button
            type="submit"
            class="action-btn primary"
            [disabled]="loading || !clinicForm.valid"
          >
            <i class="pi pi-check mr-2" *ngIf="!loading"></i>
            <i class="pi pi-spinner pi-spin mr-2" *ngIf="loading"></i>
            {{
              loading
                ? data
                  ? "Updating..."
                  : "Creating..."
                : data
                ? "Update Clinic"
                : "Register Clinic"
            }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
